import * as React from 'react';
import { connect } from 'react-redux';
import { postToController } from '../../actions/apiActions';
import { hideLoadingScreen, showLoadingScreen } from '../../actions/fullscreenActions';
import { avsValidateBankingDetails, clearMetadata, getLifeBankingDetailsPage, getSpecialDebitDays, requestDebicheckMandate, saveBankingDetails, setCollectionToSchedule, submitScheduleSpecialDebit, updateDebitOrderDate } from '../../actions/lifePolicyActions';
import { navigateTo } from '../../actions/navigationActions';
import { LIFE_PAYMENT_DETAILS } from '../../routes/routes';
import { ChangeBankingDetails } from './ChangeBankingDetails';
import './LifeChangeBankingDetails.css';
import { LifeChangeBankingDetailsFooter } from './LifeChangeBankingDetailsFooter';
import { LifeChangeBankingDetailsForm } from './LifeChangeBankingDetailsForm';

interface State {
    collectionPageAmount: number;
    bankInfoLoading: boolean;
    bankInfoList: any;
    accountTypeList: any;
    branchList: any;
    debitDayList: any;  
    bankList: any;
    bankingDetails: {
        bankName: string;
        branchCode: string;
        accountType: string;
        accountNumber: string;
        premiumPayerType: string;
        debitOrderDate: string;
    }
}

class LifeChangeBankingDetails extends React.Component<any, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            bankList: [],
            bankInfoList: [],
            accountTypeList: [],
            branchList: [],
            debitDayList: [],
            collectionPageAmount: 8,
            bankInfoLoading: false,
            bankingDetails: {
                bankName: '',
                branchCode: '',
                accountType: '',
                accountNumber: '',
                premiumPayerType: '',
                debitOrderDate: '',
            }
        }
        
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleChange = this.handleChange.bind(this); 
        this.handleAvsValidateBankingDetails = this.handleAvsValidateBankingDetails.bind(this);
        this.handleDebicheckContinue = this.handleDebicheckContinue.bind(this);
        this.handleRedirectTo = this.handleRedirectTo.bind(this);
    }

    async componentDidMount() {
        await this.getBankInfo();

        const { lifePolicy } = this.props;
        let policy = lifePolicy.policy;
        let accountNumber = '';
        let accountType = '';
        let branchCode = '';
        let bankName = '';
        let premiumPayerType = '';
        if (policy.bankingDetails) {
            accountNumber = policy.bankingDetails.accountNumber;
            accountType = policy.bankingDetails.accountType;
            branchCode = policy.bankingDetails.branchCode;
            bankName = policy.bankingDetails.bankName;
            premiumPayerType = policy.premiumPayer.parentId === policy.primaryContactId ? 'Policyholder' : 'Someone else';
        }

        let bankingDetails = {
            accountNumber,
            accountType,
            branchCode,
            bankName,
            premiumPayerType,
            debitOrderDate: policy.debitOrderDateFriendly,
        };

        if (premiumPayerType === 'Someone else') {
            bankingDetails['relationship'] = policy.premiumPayer.party.relationship;
            bankingDetails['name'] = policy.premiumPayer.party?.name;
            bankingDetails['surname'] = policy.premiumPayer.party?.surname;
            bankingDetails['idNumber'] = policy.premiumPayer.party?.idNumber;
            bankingDetails['notes'] = policy.premiumPayer.party?.notes;
            bankingDetails['title'] = policy.premiumPayer.party?.title;
            bankingDetails['email'] = policy.premiumPayer.party?.email;
            bankingDetails['phoneNumber'] = policy.premiumPayer?.party.phoneNumber;
        }
        this.setState({
            bankingDetails,
        });
    }

    async getBankInfo() {
        await this.setState({
            bankInfoLoading: true,
        });

        try {
            await postToController(this.props.dispatch, 'GetLifeBankInfo', JSON.stringify({})).then(async (response) => {
                await this.setState({
                    bankList: response.bankInfoList,
                    accountTypeList: response.bankAccountTypeList,
                    debitDayList: response.debitOrderDateList,
                });
                return true;
            });
        } finally {
            await this.setState({
                bankInfoLoading: false,
            });
        }
    }

    handleConfirm() {
        this.props.emitHandleConfirm(this.state.bankingDetails);
    }

    handleBack() {
        this.props.emitHandleBack();
    }

    async handleAvsValidateBankingDetails() {
        const val = this.state.debitDayList.filter((debitDay) => debitDay.text === this.state.bankingDetails.debitOrderDate)[0];
        this.props.dispatchAvsValidateBankingDetails({
            ...this.state.bankingDetails,
            debitOrderDate: val.value
        });
    }

    async handleDebicheckContinue(e) {
        await this.props.dispatchRequestDebicheckMandate(e['debicheckAuthenticationType']);
        this.handleRedirectTo(LIFE_PAYMENT_DETAILS);
    }

    handleRedirectTo(destination) {
        this.props.redirectTo(destination);
    }

    async handleChange(e: any) {
        await this.setState({ ...this.state, bankingDetails: { ...this.state.bankingDetails, ...e } });
    }
    
    public render() {
        let form = <LifeChangeBankingDetailsForm
            bankInfoLoading={ this.state.bankInfoLoading }
            accountTypeList = { this.state.accountTypeList }
            bankInfoList = { this.state.bankList }
            bankingDetails={this.state.bankingDetails}
            debitDayList = { this.state.debitDayList }
            debitOrderDate = { this.state.bankingDetails.debitOrderDate }
            emitHandleChange = { this.handleChange }
        ></LifeChangeBankingDetailsForm>

        let footer = <LifeChangeBankingDetailsFooter
            success={this.props.lifePolicy.metadata?.bankingDetails?.avsStatus === 'valid'}
            error={this.props.lifePolicy.metadata?.bankingDetails?.error}
            saving={this.props.lifePolicy.metadata?.bankingDetails?.avsStatus === 'validating'}
            debicheckError={this.props.lifePolicy.metadata?.debicheck?.error}
            debicheckSaving={this.props.lifePolicy.metadata?.debicheck?.status === 'saving'}
            debicheckSuccess={this.props.lifePolicy.metadata?.debicheck?.status === 'success'}
            accountNumber={this.state.bankingDetails.accountNumber}
            bankName={this.state.bankingDetails.bankName}
            debitOrderDate={this.state.bankingDetails.debitOrderDate}
            debitOrderDateDay={"25"}
            premium={this.props.lifePolicy?.policy?.premium}
            emitHandleDebicheckContinue={this.handleDebicheckContinue}
            emitHandleValidate={this.handleAvsValidateBankingDetails}>
        </LifeChangeBankingDetailsFooter>

        return (
            <>
                <ChangeBankingDetails
                    premium={this.props.lifePolicy?.policy?.premium}
                    disableForm={false}
                    saving={this.props.saving}
                    error={this.props.error}
                    success={this.props.success}
                    emitHandleConfirm={this.props.emitHandleConfirm}
                    emitHandleBack={this.props.emitHandleBack}
                    formComponent={form}
                    footerComponent={footer}
                >
                </ChangeBankingDetails>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
        lifePolicy: state.lifePolicy,
        router: state.router,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowLoadingScreen: () => dispatch(showLoadingScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchGetLifeBankingDetailsPage: (count: number, skip: number, more?: boolean) => dispatch(getLifeBankingDetailsPage(count, skip, more)),
        dispatchGetSpecialDebitDays: () => dispatch(getSpecialDebitDays()),
        dispatchSetCollectionToSchedule: (id) => dispatch(setCollectionToSchedule(id)),
        dispatchSaveBankingDetails: (bankingDetails) => dispatch(saveBankingDetails(bankingDetails)),
        dispatchAvsValidateBankingDetails: (bankingDetails) => dispatch(avsValidateBankingDetails(bankingDetails)),
        dispatchRequestDebicheckMandate: (authType) => dispatch(requestDebicheckMandate(authType)),
        dispatchPersistDebitOrderDate: (date, text) => dispatch(updateDebitOrderDate(date, text)),
        dispatchSubmitScheduleSpecialDebit: (date) => dispatch(submitScheduleSpecialDebit(date)),
        dispatchResetMetadata: () => dispatch(clearMetadata()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeChangeBankingDetails);